// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalUpdateLocation_wrapper__1v3vA","buttonAction":"ModalUpdateLocation_buttonAction__2eWxg"};